import Utils from "@base/utils/Utils"
import Signals from "@/signals/GameSignals";
import Facade from "@/Facade";

export default class URLParser {

  constructor() {
    this.player_uid = null
    this.currency = null
    this.platform = null
    this.language = null
    this.country = null
    this.customer = ''
    this.ext_params = {}
    this.init()
  }

  init() {
    this.parseUrlSettings()
  }

  parseUrlSettings() {

    this.game_code = Utils.getUrlParam('game_code', this.game_code)
    this.player_uid = Utils.getUrlParam('player_uid', this.player_uid)
    this.currency = Utils.getUrlParam('currency', this.currency)
    this.platform = Utils.getUrlParam('platform', this.platform)
    this.language = Utils.getUrlParam('language', this.language)
    this.country = Utils.getUrlParam('country', this.country)
    this.customer = Utils.getUrlParam('customer', this.customer)
    this.playForFun = Utils.getUrlParam('play_for_fun') != 'false';
    this.ext_params = Utils.searchParam('ext_params')

    this.data = {
      gameCode: this.game_code,
      platform: this.platform,
      currency: this.currency,
      language: this.language,

      country: this.country,
      player_uid: this.player_uid,
      ext_params: this.ext_params,
      customer: this.customer,
      playForFun: this.playForFun,
    }

    if (this.customer === 'betconstruct') {
      let lobby_url = this.ext_params['lobby_url'] || this.ext_params['lobbyurl'] || '';
      const [start, end] = decodeURIComponent(lobby_url).split('?');
      lobby_url = start + '?' + encodeURIComponent(end);
      this.ext_params['lobby_url'] = this.ext_params['lobbyurl'] = lobby_url;
    }

    Facade.urlParams = this.data;
    Signals.urlSettings.dispatch(this.data);
  }

}
